import { Flex, Popconfirm } from 'antd';
import { Input } from 'formik-antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt, FaTrash } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import DateComponent from '~/components/DateComponent';
import FormControl from '~/components/Form/FormControl';
import InputCurrency from '~/components/Form/InputCurrency';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';
import { formatPrice } from '~/Utils/format';

export const patrimoniesColumns = (handleDelete, handleEdit, isMobile) => {
  const prices = (record) => {
    let plus = 0;

    if (record.patrimony_payments && Array.isArray(record.patrimony_payments)) {
      record.patrimony_payments.forEach((payment) => {
        plus += parseFloat(payment.price || 0);
      });
    }

    return plus;
  };

  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record.name}
            <br />
            <Strong>{i18next.t('screens:Valor')}:</Strong> {formatPrice(prices(record))}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@assets/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@assets/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('screens:Valor'),
      dataIndex: 'price',
      key: 'price',
      width: '300px',
      render: (_, record) => formatPrice(prices(record)),
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button style={{ margin: 'auto' }} size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@assets/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@assets/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const patrimonyPaymentsColumns = (errors, fluidPermissions) => {
  return [
    {
      title: i18next.t('Descrição'),
      dataIndex: 'description',
      key: 'description',
      width: '40%',
      render: (_, record, index) => (
        <FormControl
          field={`patrimony_payments.${index}.description`}
          error={errors?.patrimony_payments?.[index]?.description}
          list
        >
          <Input name={`patrimony_payments.${index}.description`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: i18next.t('Data de Aquisição'),
      dataIndex: 'acquired_at',
      key: 'acquired_at',
      width: '40%',
      render: (_, record, index) => (
        <>
          <FormControl
            field={`patrimony_payments.${index}.acquired_at`}
            error={errors?.patrimony_payments?.[index]?.acquired_at}
            list
          >
            <DateComponent name={`patrimony_payments.${index}.acquired_at`} disabled={!fluidPermissions()} />
          </FormControl>
        </>
      ),
    },
    {
      title: i18next.t('Preço'),
      dataIndex: 'price',
      key: 'price',
      width: '50%',
      render: (_, record, index) => (
        <FormControl
          field={`patrimony_payments.${index}.price`}
          error={errors?.patrimony_payments?.[index]?.price}
          list
        >
          <InputCurrency name={`patrimony_payments.${index}.price`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Flex align="center" justify="center">
          <Button
            color="danger"
            title="Remover pagamento de patrimônio"
            size="small"
            style={{ width: '30px' }}
            onClick={() => record.remove(index)}
            disabled={!fluidPermissions()}
            icon={<FaTrash />}
          />
        </Flex>
      ),
    },
  ];
};
